import { Injectable, inject } from '@angular/core';
import { CustomizationStore } from '@app/state/customization';
import { withTransaction } from '@datorama/akita';
import { CommonConstants } from '../constants/common.constant';
import { Customization, MatchType } from '@models/profileConfiguration/model';
import { Observable } from 'rxjs';
import { ServiceFactory } from './service.factory';

@Injectable({
  providedIn: 'root',
})
export class CustomizationService {
  private serviceFactory = inject(ServiceFactory);
  private customizationStore = inject(CustomizationStore);

  public getCustomizationByClientId(clientId: string): Observable<Customization[]> {
    const searchCriteria = [
      {
        key: 'parentId',
        value: clientId,
        matchType: MatchType.EXACT,
      },
    ];
    return this.serviceFactory.post<Customization[]>(CommonConstants.getPath.profile.configurationKey, CommonConstants.getPath.profile.getCustomization, searchCriteria).pipe(
      withTransaction((customization) => {
        this.customizationStore.set(customization);
        const lastCustomization = customization[customization.length - 1];
        this.customizationStore.setActive(lastCustomization?.id);
      })
    );
  }
}
